import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import ClosureWarningIcon from 'components/Icons/ClosureWarningIcon';
import { colors } from 'theme';
import { ClosureValidateViolation } from 'types';

const useStyles = makeStyles(theme => ({
  closureWarning: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'start',
    flexDirection: 'column',
    margin: '0 auto',
  },
  warningBody: {
    display: 'flex',
    margin: '0 10%',
    paddingTop: '25px',
    paddingLeft: '30px',
  },
  warningHeader: {
    color: colors.darkOrange,
    maxWidth: '686px',
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    marginTop: '25px',
  },
  warningIcon: {
    flexShrink: 0,
    marginRight: '26px',
    width: '71px',
    height: '71px',
  },
  warningTitle: {
    fontSize: '18px',
    lineHeight: '21px',
    margin: 'auto 0',
    display: 'flex',
    alignItems: 'center',
    height: '78px',
  },
  warningText: {
    fontSize: '18px',
    lineHeight: '21px',
  },
}));

type ClosureWarningProps = {
  title?: string;
  text?: string;
  warningsList?: ClosureValidateViolation[];
};

const ClosureWarning: React.FC<ClosureWarningProps> = (props: ClosureWarningProps) => {
  const classes = useStyles();
  const warningsList = props.warningsList;

  return (
    <div className={classes.closureWarning}>
      <div className={classes.warningHeader}>
        <ClosureWarningIcon className={classes.warningIcon} />
        <Typography className={classes.warningTitle}>{props.title}</Typography>
      </div>
      <div className={classes.warningBody}>
        {!!props.text ? (
          <Typography className={classes.warningText}>{props.text}</Typography>
        ) : (
          !!warningsList &&
          warningsList.length > 0 && (
            <ul>
              {warningsList.map((warning: ClosureValidateViolation, index: number) => {
                const key = `${warning.message}_${index}`;
                return <li key={key}>{warning.message}</li>;
              })}
            </ul>
          )
        )}
      </div>
    </div>
  );
};
export default ClosureWarning;
